<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/receipts">{{$t('sale_receipt')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{model.Num}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <template v-if="model.Status=='Draft'">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
                <button type="button" class="btn btn-outline-danger btn-sm no-bor" @click="confirmDelete"><i class="fa fa-times"></i> {{ $t('delete') }}</button>
            </template>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <h2>CASH RECEIPT</h2>
                            <p>DATE: {{$format(model.Date,'DD/MM/YYYY')}}</p>
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th style="width: 175px;">Received from</th>
                                        <td colspan="3">{{model.CustomerName}}</td>
                                    </tr>
                                    <tr>
                                        <th>Receipt #</th>
                                        <td>{{model.Num}}</td>
                                        <td>Invoice #</td>
                                        <td>{{model.DocSourceNo}}</td>
                                    </tr>
                                    <tr>
                                        <td>Purpose of payment</td>
                                        <td colspan="3">{{model.Description}}</td>
                                    </tr>
                                    <tr>
                                        <td>Payment made by</td>
                                        <td>{{model.CreatedBy}}</td>
                                        <td>Total Amount</td>
                                        <td style="color: #0856ab;">{{$money(model.Balance)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Payment received by</td>
                                        <td>{{account.Name}}</td>
                                        <td>Amount Received</td>
                                        <td style="color: green;">{{$money(model.Amount)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Authorized Signature By</td>
                                        <td>{{model.ApprovedDate}}</td>
                                        <td>Signature Date</td>
                                        <td>{{model.ApprovedDate}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Swal from 'sweetalert2';
    export default {
        data: function(){
            return {
                model:{},
                account: {},
                customer: {}
            }
        },
        created: function(){
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('sale/receipt/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        this.account = res.data.Json.Account;
                        if(res.data.Json.Customer != null)
                            this.customer = res.data.Json.Customer;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('sale/receipt/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            confirmDelete(){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                    if (result.value) {
                        this.deleteById();
                    }
                });
            },
            deleteById(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('sale/receipt/cancel', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>